import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAppMeta } from "hooks";
import { useGetVendorQuotationExcelDetailQuery, useUpdateVendorQuotationExcelMutation } from "store/services/vendorQuotationExcelApi";
import VendorQuotationExcelForm from "./vendorQuotationExcelComponents/VendorQuotationExcelForm";

const VendorQuotationExcelEditScreen = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const breadcrumbs = [
        { title: "Vendor Quotation Excels", path: "/app/crm/vendor-quotation-excel/list" },
        { title: "Edit Vendor Quotation Excel" },
    ];

    const {
        data: priceListDetail,
        isLoading: loadingPriceList,
        error,
    } = useGetVendorQuotationExcelDetailQuery(id);

    const [updatePriceList, { isLoading: updatingPriceList }] =
        useUpdateVendorQuotationExcelMutation();

    const handleUpdate = async (data) => {
        try {
            await updatePriceList({ _id: id, ...data }).unwrap();
            toast.success("Vendor Quotation Excel successfully updated!");
            navigate(`/app/crm/vendor-quotation-excel/${id}/detail`);
        } catch (err) {
            toast.error(
                err?.data?.message ?? err?.message ?? "Couldn't update Vendor Quotation Excel!",
            );
        }
    };

    useAppMeta("Edit Vendor Quotation Excel");

    return (
        <BreadcrumbLayout
            breadcrumbs={breadcrumbs}
            isBusy={loadingPriceList || updatingPriceList}
        >
            <BreadcrumbLayout.Error error={error} />
            <BreadcrumbLayout.Paper>
                <VendorQuotationExcelForm
                    isBusy={loadingPriceList || updatingPriceList}
                    priceListDetail={priceListDetail}
                    onSubmit={handleUpdate}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default VendorQuotationExcelEditScreen;